import {GEButton} from '../../../../../common/buttons'
import * as API_AI from '../../../../../shared/http/openai'
import {FC, useState} from 'react'
import WordUtils from '../../../../utils/WordUtils'
import {WordDto} from '../../../../../shared/types/api'
import {useAppDispatch, useAppSelector} from '../../../../../store/hooks'
import {setWordsRoutine, wordsDataSelector} from '../../../../../store/words'
import Constants from '../../../../../const/Constants'
import {premiumStatusSelector} from '../../../../../store/global'
import {MagicIcon} from '../../../../elements/svg_icons/MagicIcon'
import {goToPageNotPremium} from "../../../../utils/goToPage";
import {NavigationPages} from "../../../../../common/navigation/navigation-pages";
import {useNavigate} from "react-router-dom";
import {Button} from "antd";

interface AddAIWordsButtonProps {
    selectedCategory: any,
    wordsAmount: number,
}

const AddAIWordsButton: FC<AddAIWordsButtonProps> = ({selectedCategory, wordsAmount}) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const isPremium = useAppSelector(premiumStatusSelector)
    const words = useAppSelector(wordsDataSelector)
    const [loading, setLoading] = useState<boolean>(false)
    const [canceledCards, setCanceledCards] = useState<Array<WordDto>>([])
    const setWordsRedux = (w: Array<WordDto>) => dispatch(setWordsRoutine(w))
    const onclickAI = () => {
        if (isPremium) {
            setLoading(true)
            API_AI.generateAIWordListCard(selectedCategory?.id, canceledCards).then(w => {
                addWord(w.engWord, w.rusWord)
            }).finally(() => {
                setLoading(false)
            })
        } else {
            goToPageNotPremium(NavigationPages.PREMIUM, navigate)
        }

    }

    const addWord = (sideOne: string, sideTwo: string) => {
        const newWord = WordUtils.createNewAiWord(selectedCategory?.id, sideOne, sideTwo)
        //@ts-ignore
        setCanceledCards([...canceledCards, newWord])
        setWordsRedux([...words, newWord])
    }

    return (
        <>
            {wordsAmount >= 1 && selectedCategory.sideOneLang &&
                selectedCategory.sideTwoLang
                && wordsAmount < Constants.MAX_COUNT_WORDS_IN_WORD_LIST &&
                <Button icon={<MagicIcon/>} loading={loading} onClick={onclickAI} color="purple" variant="outlined">
                    Добавить карточку с ИИ
                </Button>

            }
        </>
    )
}

export default AddAIWordsButton